import { Component, Input, OnInit, Inject } from '@angular/core'
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
    selector: 'copy-dialog',
    template: `
    <h1 mat-dialog-title>Etes vous sûr ?</h1>
    <div mat-dialog-content></div>
    <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Copier</button>
    <button mat-button (click)="onNoClick()">Annuler</button>
    </div>
    `,
  })
  export class CopyDialog {
  
    constructor(
      public dialogRef: MatDialogRef<CopyDialog>,
      @Inject(MAT_DIALOG_DATA) public data: string) {}
  
    public onNoClick(): void {
      this.dialogRef.close();
    }
  
  }